import React from "react";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import styles from "../styles/switchPGWarning.module.css";
import dashboardStore from "../store/dashboardStore";
import commonStore from "../../Store/marco/commonStore";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";

export const SwitchPageWarningModal = observer(() => {
  const store = dashboardStore;
  const cmStore = commonStore;
  const { t } = useTranslation("ActivityMain");

  /** --- Leave：不儲存直接切換 --- */
  const handleLeave = () => {
    store._handleSetShowDashboardWarningModal(false);
    cmStore.leaveWithoutSave();
  };

  /** --- Cancel：回到編輯，什麼也不做 --- */
  const handleCancel = () => {
    store._handleSetShowDashboardWarningModal(false);
    cmStore._handleClearPendingAction();
  };

  /** --- Save：保存後切換 --- */
  const handleSave = async () => {
    store._handleSetShowDashboardWarningModal(false);
    await cmStore.saveAndLeave();
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modalContainer}>
        <div className={styles.iconWrap}>
          <WarningRoundedIcon color="warning" fontSize="large" />
        </div>

        <div className={styles.textBlock}>
          <div className={styles.title}>
            {t("It looks like you have unsaved changes.")}
          </div>
          <div className={styles.subtitle}>
            {t("Would you like to save your changes first?")}
          </div>
        </div>

        <div className={styles.btnRow}>
          <button className={styles.btnLeave} onClick={handleLeave}>
            {t("No, Leave.")}
          </button>
          <button className={styles.btnCancel} onClick={handleCancel}>
            {t("Cancel, return to edit.")}
          </button>
          <button className={styles.btnSave} onClick={handleSave}>
            {t("Yes, save edits.")}
          </button>
        </div>
      </div>
    </div>
  );
});
